(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/unauthorized-landing.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/unauthorized-landing.js');
"use strict";

const UnauthorizedLanding = _ref => {
  let {
    numberOfTickets,
    totalPrice,
    history
  } = _ref;
  const isGift = Boolean(numberOfTickets && totalPrice);
  const BubbleInfo = svs.tur.bubbleInfo.components.BubbleInfo;
  const CustomerService = svs.ticket_gifts.redeem.components.CustomerService;
  const Payfooter = svs.tur.ReactPayfooter.Payfooter;
  const reactPayfooterCustomerServiceTexts = [{
    content: React.createElement("p", {
      className: "f-550 tg-customer-service-margin-1"
    }, "Beh\xF6ver du hj\xE4lp?")
  }, {
    content: React.createElement(CustomerService, null)
  }];

  const playerRegistrationExtraData = {
    amount: totalPrice,
    product: 'Triss',
    weeks: numberOfTickets,
    subscription: false,
    gift: true,
    branding: ''
  };
  const handleStoreClick = e => {
    e && e.preventDefault();
    history && history.push("".concat(history.location.pathname, "/streckkod").concat(history.location.search));
  };
  const handleRedeemOnlineClick = e => {
    e && e.preventDefault();
    svs.components.customer_login.login({
      returnNewCustomer: true,
      extraParams: playerRegistrationExtraData
    });
  };
  const payfooterButtons = [{
    primary: true,
    text: 'Skrapa online',
    onClick: handleRedeemOnlineClick,
    description: {
      content: 'Vinst sätts in direkt på ditt personliga spelkonto. Är du inte kund blir du det enkelt med BankID.'
    }
  }, {
    secondary: true,
    text: 'Hämta i butik',
    onClick: handleStoreClick,
    description: {
      content: 'Du kan välja att hämta din lott i alla butiker som säljer Triss. 18 år och legitimation gäller.'
    }
  }];
  let headerBubbleContent = React.createElement("div", {
    className: "f-body"
  }, React.createElement("h2", {
    className: "h2 margin-0"
  }, "Hej!", React.createElement("br", null), " Kul att du \xE4r h\xE4r!"));
  let messageBubbleContent = React.createElement("div", {
    className: "f-body"
  }, React.createElement("p", {
    className: "p margin-0"
  }, "Nu kan du v\xE4lja om du vill skrapa online eller h\xE4mta i butik."));
  let imgSrc = "".concat(svs.core.config.data.svsconfig.cdn, "/images/ticket-gifts/SvS-Tur-presentpaket-mockup.png");
  if (isGift) {
    messageBubbleContent = null;
    imgSrc = "".concat(svs.core.config.data.svsconfig.cdn, "/images/ticket-gifts/SvS-Tur-presentpaket-mockup.png");
    switch (true) {
      case Number(numberOfTickets) === 1:
        headerBubbleContent = "Du har f\xE5tt 1 presentlott till ett v\xE4rde av ".concat(totalPrice, " kr!");
        break;
      case numberOfTickets > 1:
        headerBubbleContent = "Du har f\xE5tt ".concat(numberOfTickets, " presentlotter till ett v\xE4rde av ").concat(totalPrice, " kr!");
        break;
      default:
    }
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "tg-container f-body",
    "data-testid": "unauthorized-container"
  }, React.createElement(BubbleInfo, {
    className: "bubble-info-container",
    header: headerBubbleContent
  }, messageBubbleContent), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center"
  }, React.createElement("img", {
    className: "tg-unauthorized-image padding-2",
    src: imgSrc
  }))), React.createElement(Payfooter, {
    buttons: payfooterButtons,
    texts: reactPayfooterCustomerServiceTexts
  }));
};
setGlobal('svs.ticket_gifts.redeem.components.UnauthorizedLanding', UnauthorizedLanding);

 })(window);